module.exports = __webpack_public_path__ + "static/media/2.deedb706.jpg";